import {
  CONFIGDATA_FAILURE,
  CONFIGDATA_REQUEST,
  CONFIGDATA_SUCCESS,
} from "../../constants/constants.js";

const initialState = {
  message: "",
  error: null,
  configData: {},
};

const ConfigdataReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONFIGDATA_REQUEST:
      return {
        ...state,
      };
    case CONFIGDATA_SUCCESS:
      return {
        ...state,
        configData: action?.payload?.data,
        message: action?.payload?.message,
        error: null,
      };
    case CONFIGDATA_FAILURE:
      return {
        ...state,
        message: action?.payload?.message,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default ConfigdataReducer;
